import { useEffect, useState } from 'react';

// Prefer the record ID so focus follows the same record after a refresh/sort.
// Without an ID, use the record itself rather than a reusable row index.
const getRowKey = (record: any): unknown =>
  record?.id != null ? String(record.id) : record;

export const useTableRowFocus = (data: readonly unknown[]) => {
  const [focusedRowKey, setFocusedRowKey] = useState<unknown>(null);

  useEffect(() => {
    if (!data.some((record) => getRowKey(record) === focusedRowKey)) {
      setFocusedRowKey(null);
    }
  }, [data, focusedRowKey]);

  return (record: unknown) => {
    const key = getRowKey(record);
    const focusRow = () => setFocusedRowKey(key);

    return {
      tabIndex: 0,
      'data-row-focused': focusedRowKey !== null && focusedRowKey === key,
      // Capture also handles editable cells and controls that stop bubbling.
      onClickCapture: focusRow,
      onFocusCapture: focusRow,
    };
  };
};
